import initialState from "./state";
import { ITakeOffToEnRouteInitialState } from "./types";
import { CaseReducer, PayloadAction } from "@reduxjs/toolkit";

const resetState: CaseReducer<ITakeOffToEnRouteInitialState, PayloadAction> = (state) => {
  return initialState;
};

const setManualControl: CaseReducer<ITakeOffToEnRouteInitialState, PayloadAction<ITakeOffToEnRouteInitialState['isManualControl']>> = (state, action) => {
  state.isManualControl = action.payload;
};

const setSerialNumber: CaseReducer<ITakeOffToEnRouteInitialState, PayloadAction<ITakeOffToEnRouteInitialState['serialNumber']>> = (state, action) => {
  state.serialNumber = action.payload;
};

export default { resetState, setManualControl, setSerialNumber };